import { createAsyncThunk } from "@reduxjs/toolkit";
import { setErrorSnackBarMessage, setSnackBarMessage } from "../systemSlice";
import { errorToHandler } from "../../api/error";
import { api } from "api";
import { AddUserRequest, ApiError } from "api/controlPlaneApi";

export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (_, { rejectWithValue, getState, dispatch }) => {
    return api.users
      .usersList()
      .then((res) => {
        return res.data.results;
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const fetchUserDetails = createAsyncThunk(
  "users/fetchUserDetails",
  async (userID: string, { rejectWithValue, getState, dispatch }) => {
    return api.users
      .userDetails(userID)
      .then((res) => {
        return res.data;
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (userID: string, { rejectWithValue, getState, dispatch }) => {
    return api.users
      .userDelete(userID)
      .then(() => {
        dispatch(setSnackBarMessage("User deleted successfully"));
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const addUser = createAsyncThunk(
  "users/addUser",
  async (user: AddUserRequest, { rejectWithValue, getState, dispatch }) => {
    return api.users
      .usersAdd(user)
      .then()
      .then(() => {
        dispatch(setSnackBarMessage("User added successfully"));
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const editUser = createAsyncThunk(
  "users/editUser",
  async (user: any, { rejectWithValue, getState, dispatch }) => {
    let id = user.id;
    delete user.id;
    return api.users
      .userEdit(id, user)
      .then(() => {
        dispatch(setSnackBarMessage("Updated User successfully"));
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);
